import { render, staticRenderFns } from "./ButtonWithDropdown.vue?vue&type=template&id=ae398444&lang=pug&"
import script from "./ButtonWithDropdown.vue?vue&type=script&lang=ts&"
export * from "./ButtonWithDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports